import CommentGeneralModel from '../Apis/CommentGeneral'
import Controller from './Controller'

export default class CommentGeneralController extends Controller {
  constructor() {
    super(new CommentGeneralModel())
  }
}
